"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactSelect = _interopRequireDefault(require("react-select"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var StyledReactSelect = /*#__PURE__*/(0, _styledComponents["default"])(_reactSelect["default"]).withConfig({
  displayName: "indexstyles__StyledReactSelect",
  componentId: "sc-19oqk5i-0"
})(["margin-top:", ";.ReactSelect__control{border-radius:0;background-color:", ";padding:", ";border-color:", ";color:", ";&:hover{border-color:", ";}&--menu-is-open,&--menu-is-open:hover,&--is-focused,&--is-focused:hover{border-color:", ";box-shadow:0 0 0 1px ", ";}&--is-disabled,&--is-disabled:hover{background-color:", ";pointer-events:all;cursor:not-allowed;border-color:", ";box-shadow:none;}}.ReactSelect__value-container{padding-top:", ";padding-bottom:", ";}.ReactSelect__multi-value{background-color:", ";}.ReactSelect__multi-value__label{color:", ";}.ReactSelect__single-value{color:", ";}.ReactSelect__menu{background-color:", ";border-radius:0;}.ReactSelect__option{&--is-focused{background-color:", ";}&--is-selected{color:", ";background-color:", ";}&--is-disabled{color:", ";cursor:not-allowed;}}.ReactSelect__indicator-separator{background-color:", ";}&.invalid{.ReactSelect__control{border-color:", ";box-shadow:0 0 0 1px ", ";}}.ReactSelect__placeholder{color:", ";}", ""], function (p) {
  return p.theme.tokens.spacing01;
}, function (p) {
  return p.theme.colorBackgroundSelect;
}, function (p) {
  return p.theme.tokens.spacing02;
}, function (p) {
  return p.theme.colorBorderSelect;
}, function (p) {
  return p.theme.colorText;
}, function (p) {
  return p.theme.colorBorderSelect;
}, function (p) {
  return p.theme.colorBorderSelectFocus;
}, function (p) {
  return p.theme.colorBorderSelectFocus;
}, function (p) {
  return p.theme.colorBackgroundSelectDisabled;
}, function (p) {
  return p.theme.colorBorderSelectDisabled;
}, function (p) {
  return p.theme.tokens.spacing02;
}, function (p) {
  return p.theme.tokens.spacing02;
}, function (p) {
  return p.theme.colorBackgroundSelectOptionSelect;
}, function (p) {
  return p.theme.colorText;
}, function (p) {
  return p.theme.colorText;
}, function (p) {
  return p.theme.colorBackgroundSelect;
}, function (p) {
  return p.theme.colorBackgroundSelectOptionHover;
}, function (p) {
  return p.theme.colorText;
}, function (p) {
  return p.theme.colorBackgroundSelectOptionSelect;
}, function (p) {
  return p.theme.colorTextSelectDisabled;
}, function (p) {
  return p.theme.colorBackgroundSelectSeparator;
}, function (p) {
  return p.theme.colorBorderSelectError;
}, function (p) {
  return p.theme.colorBorderSelectError;
}, function (p) {
  return p.theme.colorTextSelectPlaceholder;
}, function (p) {
  var width;

  switch (p.size) {
    case 'xs':
      width = '5rem';
      break;

    case 's':
      width = '10rem';
      break;

    case 'm':
      width = '20rem';
      break;

    case 'l':
      width = '30rem';
      break;

    case 'xl':
      width = '46rem';
      break;

    default:
      console.warn("invalid size '".concat(p.size, "' provided. the supported values are xs, s, m, l and xl"));
  }

  return (0, _styledComponents.css)(["width:", ";"], width);
});
var _default = StyledReactSelect;
exports["default"] = _default;